/**
 * Customer Website Formatter.
 *
 * Renders the website as a link (new tab, rel="noreferrer nofollow") while
 * displaying it without the protocol or trailing slash.
 *
 * The website is attacker-controllable (it can be set through the public API),
 * so the link is built with DOM APIs — which attribute-encode safely — instead
 * of string concatenation, and only http(s) URLs become links.
 */
window.customerWebsiteFormatter = function(value, row) {
    if (!value) {
        return '';
    }

    let href = /^https?:\/\//i.test(value) ? value : 'https://' + value;
    let label = value.replace(/^https?:\/\//i, '').replace(/\/+$/, '');

    // Defence in depth: never emit a non-http(s) link.
    if (!/^https?:\/\//i.test(href)) {
        return document.createTextNode(label).textContent;
    }

    let a = document.createElement('a');
    a.href = href;
    a.target = '_blank';
    a.rel = 'noreferrer nofollow';
    a.textContent = label;

    return a.outerHTML;
};
